import { CurrencyEuroIcon } from "@heroicons/react/20/solid";
import { createColumnHelper } from "@tanstack/react-table";
import clsx from "clsx";

import type { ProjectsTimeTrackingsTableData } from "~/modules/project/types/projectViewTypes.ts";
import { formatCentsToCurrency } from "~/utils/currencyUtils.ts";
import { formatDateWithGermanMonth, formatHoursAndMinutes } from "~/utils/dateAndTimeUtils.ts";
import { customArrayIncludesSome, customDateFilter } from "~/utils/tanStackTableUtils.ts";

const columnHelper = createColumnHelper<ProjectsTimeTrackingsTableData>();

export const projectsTimeTrackingTableColumnDefs = [
	columnHelper.accessor("date", {
		header: "Datum",
		cell: props => formatDateWithGermanMonth(props.getValue()),
		filterFn: customDateFilter,
		meta: {
			width: "9.5rem",
		},
	}),
	columnHelper.accessor("userId", {
		header: "Mitarbeiter",
		meta: {
			cellTextAlign: "left",
			headerTextAlign: "left",
			width: "13%",
		},
		sortingFn: "text",
		enableSorting: true,
		filterFn:customArrayIncludesSome,
		cell: props => props.row.original.userFullName,
	}),
	columnHelper.accessor("phaseId", {
		header: "Phase",
		filterFn:customArrayIncludesSome,
		cell: props => props.row.original.phaseTitle,
		meta: {
			cellTextAlign: "left",
			headerTextAlign: "left",
			width: "12%",
		},
	}),
	columnHelper.accessor("orderTitle", {
		header: "PO",
		meta: {
			cellTextAlign: "left",
			headerTextAlign: "left",
			width: "10%",
		},
	}),
	columnHelper.accessor("deliverablesText", {
		header: "Buchungstext",
		meta: {
			cellTextAlign: "left",
			width: "auto",
		},
		cell: props => props.row.original.deliverablesText,
	}),

	columnHelper.accessor("dailyRateCents", {
		header: "Tagessatz",
		meta: {
			cellTextAlign: "right",
			headerTextAlign: "right",
			width: "7.5rem",
		},
		cell: props => {
			const dailyRateCents = props.getValue();
			if(dailyRateCents === 0){
				return "--";
			}

			return formatCentsToCurrency(props.getValue());
		}
	}),
	columnHelper.accessor("minutesTracked", {
		header: "Dauer",
		cell: props => formatHoursAndMinutes(props.getValue()),
		meta: {
			width: "6rem",
		},
	}),
	columnHelper.accessor("totalAmountCents", {
		header: "Kosten",
		meta: {
			cellTextAlign: "right",
			headerTextAlign: "right",
			width: "8rem",
		},
		cell: props => formatCentsToCurrency(props.getValue()),
	}),
	columnHelper.accessor("isBillable", {
		id: "isBillable",
		header: "",
		enableSorting: false,
		filterFn:customArrayIncludesSome,
		meta: {
			width: "3rem",
			cellTextAlign: "center",
			headerTextAlign: "center",
		},
		cell: props => <CurrencyEuroIcon className={clsx("mx-auto size-4", props.getValue() ? "text-success-500" : "text-danger-500")} />,
	})
];
